import { SettingsApiService } from '@services';

import { LOCATIONS_NAMESPACE } from './locations.types';

import { MutationTypes, ActionTypes } from './settings.types';

export default {
  namespaced: true,

  state: {
    digitalSettings: {},
  },

  mutations: {
    [MutationTypes.SET_APP_DIGITAL_SETTINGS](state, payload) {
      state.digitalSettings = payload;
    },
  },

  actions: {
    async [ActionTypes.GET_APP_DIGITAL_SETTINGS](
      { commit, rootState: { [LOCATIONS_NAMESPACE]: appLocations } },
      { suffix = appLocations.suffix } = {},
    ) {
      commit(
        MutationTypes.SET_APP_DIGITAL_SETTINGS,
        await SettingsApiService.getDigitalSettings({ suffix }),
      );
    },
  },

  getters: {
    // @TODO only negative values for now, update this is block if it'll change in future
    timeZoneUTCShift: ({ digitalSettings: { dateShiftHoursFromUTC: t } }) => -t || 0,
  },
};
